// 분배금 API (tb_dividend)
import axiosInstance from './axiosInstance';

// 분배금 목록 조회 (연도별 1~12월 그리드 데이터)
// params: { year?, account_name?, base_date? }
export const fetchDividendList = async (params = {}) => {
  const res = await axiosInstance.get('/dividend/list', { params });
  return res.data;
};

// 변경된 분배금 일괄 저장
// payload: { year, items: [{account_name, ticker, month, amount, invest_amount}, ...] }
export const saveDividends = async (payload) => {
  const res = await axiosInstance.post('/dividend/save', payload);
  return res.data;
};

// 분배금 현황 조회 (현황화면용)
// params 객체: { year, account_name?, term_type?, sector?, include_interest }
export const fetchDividendSummary = async (params) => {
  const res = await axiosInstance.get('/dividend/summary', { params });
  return res.data;
};
